import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextAlignRightFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M4 6h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4m24 4H11a2 2 0 0 0 0 4h17a2 2 0 0 0 0-4m0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4m0 8H17a2 2 0 0 0 0 4h11a2 2 0 0 0 0-4"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTextAlignRightFilledSVG);
ForwardRef.displayName = "IconTextAlignRightFilled";
export { ForwardRef as IconTextAlignRightFilled };
